<template>
<div class="share">
  <img v-if="isYd" class="image" :src="isIos ? require('../../assets/image/shequ/ios.png') : require('../../assets/image/shequ/an.png')" alt="">
  <div :class="[isBg&&'bg']" v-if="isWeixin&&isTrue&&!isIos">
    <div class="bottom_box fixed"  @click="startApp">
      <wx-open-launch-app id="launch-btn" appid="wx749d9eeb5dd440f6" :extinfo="`com.sjbox.az://communityData=${href}`">
        <script type="text/wxtag-template">
          <style>.bottom_btn {
            width: 300px;
            height: 40px;
            background: linear-gradient(90deg, #1d1d1d 0%, #5b4e3f 100%);
            border-radius: 20px 20px 20px 20px;
            line-height: 40px;
            text-align: center;
            color: #ffffff;
            font-size: 14px;
            margin: 10px auto;
            color: #ffdb89;
          }</style>
          <div class="bottom_btn">{{text}}</div>
        </script>
      </wx-open-launch-app>
    </div>
  </div>
  <div :class="[isBg&&'bg']" v-else  @click="startApp">
    <div class="bottom_box fixed">
      <div class="bottom_btn">{{text}}</div>
    </div>
  </div>
</div>
</template>

<script>
import { callApp } from '@/utils/down'
export default {

  props: {
    text: {
      type: String,
      default: '打开App'
    },
    isBg: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    isIos(){
      return /iPhone|iPad|iPod/i.test(navigator.userAgent)
    },
    isWeixin() {
      var isComWx = /wxwork/i.test(navigator.userAgent); // 是否企业微信
      return /MicroMessenger/i.test(navigator.userAgent) && !isComWx
    },
    isWx(){
      return /MicroMessenger/i.test(navigator.userAgent)
    },
    isQQ() {
      var isIosQQ = ( /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent) && /\sQQ/i.test(navigator.userAgent));
      var isAndroidQQ = ( /(Android)/i.test(navigator.userAgent) && /MQQBrowser/i.test(navigator.userAgent) && /\sQQ/i.test((navigator.userAgent).split('MQQBrowser')));
      return isIosQQ || isAndroidQQ
    },
    href() {
      return location.pathname + location.search
    }
  },

  data() {
    return {
      message: '',
      isTrue: true,
      isYd: false
    };
  },

async mounted() {
  var that = this
    if(!this.isWeixin) return
    const {data} = await this.$ajax('/Wechat/wechatSignData',{
      url: location.href
    })
    // const data = {
    //   appid: 'wxa314507a423396a5',
    //   timestamp: '1736838831',
    //   nonceStr: 'hi3eMLqDb2VJR81o',
    //   signature: '19b31d95fb1cb5b95d730886bcc60458b46b7417'
    // }
    wx.config({
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印
      appId: data.appid, // 必填，公众号的唯一标识
      timestamp: data.timestamp, // 必填，生成签名的时间戳
      nonceStr: data.nonceStr, // 必填，生成签名的随机串
      signature: data.signature,// 必填，签名
      jsApiList: ['launchApplication','wx-open-launch-app'], // 必填，需要使用的JS接口列表
      openTagList: ['wx-open-launch-app'] // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
    });
    wx.ready(function () {
      // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中
      var btn = document.getElementById('launch-btn');
      btn.addEventListener('launch', function (e) {
        console.log('success');
        that.startApp()
      });
      btn.addEventListener('error', function (e) {
        that.startApp()
        console.log('fail', e.detail);
        that.message = JSON.stringify(e.detail)
      });
    })
    wx.error(function (res) {
      // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名
      console.log('config信息验证失败',res);
      that.message =JSON.stringify(res) 
      that.isTrue = false
    })
    document.addEventListener('WeixinOpenTagsError', function (e) {
      console.error(e.detail.errMsg); // 无法使用开放标签的错误原因，需回退兼容。仅无法使用开放标签，JS-SDK其他功能不受影响
      this.message = e.detail.errMsg
    });

  },

  methods: {
    async startApp() {
      if(this.isQQ || this.isWx) {
        this.isYd = true
        this.$emit('openYd')
        return
      }
      const data = location.pathname + location.search
      // if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
      //   //判断iPhone|iPad|iPod|iOS
      //   location.href = 'com.sjbox.az://'
      // } else if (/(Android)/i.test(navigator.userAgent)) {
      //   //判断Android
      await callApp(data, 2000)
      // }
    },

  },
};
</script>

<style lang="scss" scoped>
.share{
  position: fixed;
  // height: calc(var(--vh, 1vh) * 100);
  top: 0;
  left: 0;
  z-index: 22222;
  .image{
    width: 100vw;
    height: calc(var(--vh, 1vh) * 100);
    position: relative;
    object-fit: cover;
    object-position: top;
    z-index: 2442;
    max-width: 523px;
    left: 50%;
    transform: translateX(-50%);
  }
}
.bg {
  position: fixed;
  width: 100vw;
  height: calc(var(--vh, 1vh) * 100);
  top: 0;
  left: 0;
  z-index: 2222;
}
.bottom_box {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 60px;
  background: #ffffff;
  border-radius: 0px 0px 0px 0px;
  z-index: 16;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
  .bottom_btn {
    width: 300px;
    height: 40px;
    background: linear-gradient(90deg, #1d1d1d 0%, #5b4e3f 100%);
    border-radius: 20px 20px 20px 20px;
    line-height: 40px;
    text-align: center;
    color: #ffffff;
    font-size: 14px;
    margin: 10px auto;
    color: #ffdb89;
  }
}
</style>